const YT_WIDGET_CATS = ['youtube', 'yt_playlist'];

// Screens with Android >= 11 play YouTube through the locally installed YouTube app.
export const YT_NATIVE_MIN_ANDROID = 11;

export const isYoutubePending = (file) => {
  if (!YT_WIDGET_CATS.includes(file?.widget?.widgetCat)) {
    return false;
  }
  const status = file?.ytStatus;
  return Array.isArray(status)
    ? status.includes('pending')
    : status === 'pending';
};

export const supportsNativeYoutube = (osVersion) => {
  const major = parseInt(osVersion, 10);
  return Number.isFinite(major) && major >= YT_NATIVE_MIN_ANDROID;
};

// Splits files into addable ones and YT files that are still processing.
export const splitYoutubePending = (
  files,
  { osVersion, isScreenTarget = false } = {},
) => {
  if (isScreenTarget && supportsNativeYoutube(osVersion)) {
    return { allowed: files, pending: [] };
  }
  return {
    allowed: files.filter((file) => !isYoutubePending(file)),
    pending: files.filter(isYoutubePending),
  };
};
